import { NotificationBase } from "./notification-base";

export default class AuthNotification extends NotificationBase {
  constructor(el) {
    super(el);

    this.initCloseListener();
    this.on('notification:auth', this.show)
  }

  initCloseListener = () => {
    const closeBtn = this.el.querySelector('.close-btn');

    closeBtn.addEventListener('click', (event) => {
      event.preventDefault();
      this.close();

      const nextDay = new Date().getDate() + 1;
      const nextDayTime =  (new Date()).setDate(nextDay);

      localStorage.setItem('showAuthNotificationAfter', nextDayTime);
    });
  }
}